import React, { Component } from "react";
import "../../../styles/sharedStyles.scss";
import { base64FileDownload } from "../../../utils/FileDownloadUtil";
import TermsDialog from "../../../shared/termsDialog/TermsDialog";
import FileEncoder from "../../../utils/FileEncoder";
import styles from "./CustomerContract.module.scss";
import { ValidatorForm } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import AgentContractHeader from "./AgentContractHeader";
import { withTranslation } from "react-i18next";
import UploadButton from "../../../imgs/upload.svg";
import AgentContractRow from "./AgentContractRow";
import AgentContractClient from "../../../shared/clients/AgentContractClient";
import HasPermissionTo from "../../../common/HasPermissionTo";

class AgentContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contracts: [],
      updateContractForAll: false,
      updateContractForADealer: false,
      uploadSuccessForAll: false,
      showErrorMessage: false,
      contractEmails: {},
      changedEmails: {},
      editMode: false,
      saveSuccess: false,
      saveError: false,
    };
    this.contractEmailsCopy = {};
    this.langCode = this.props.lang ? this.props.lang.substr(0, 2) : "";
    this.viewingAll = false;
  }

  componentDidMount() {
    this.getAgentContract();
  }

  handleContractDownload = (file) => {
    //base64FileDownload(file.contract, "application/pdf", file.fileName);
    base64FileDownload(file.contract, "application/pdf", "AgentTerms.pdf");
  };

  handleEmailChange = (nsc, event) => {
    const currentContractEmails = JSON.parse(
      JSON.stringify(this.state.contractEmails)
    );
    currentContractEmails[nsc] = event.target.value;
    this.updateChangedList(nsc, event.target.value, currentContractEmails);
  };

  getAgentContract = (showMessage) => {
    this.props.hideOrShow(true);
    AgentContractClient.getAgentContract(
      this.props.user.token,
      this.props.user.market
    )
      .then((contract) => {
        const contractsList = [];
        const contractEmails = {};

        if (contract) {
          contract.name = "AgentTerms";
          contract.nsc = "NSC";
          contract.market = this.props.user.market;

          if (showMessage) {
            contract.showMessage = true;
          }
          contractsList.push(contract);
          contractEmails[contract.nsc] = contract.email;
        }

        this.setState(
          {
            contracts: contractsList,
            contractEmails,
          },
          () =>
            (this.contractEmailsCopy = JSON.parse(
              JSON.stringify(this.state.contractEmails)
            ))
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  updateAlltheFlags = () => {
    this.setState({
      uploadSuccessForAll: false,
      showErrorMessage: false,
      saveError: false,
      saveSuccess: false,
    });
  };

  saveAgentContract = (dealerIds, file) => {
    this.props.hideOrShow(true);
    this.updateAlltheFlags();
    const updateContractForAll = this.state.updateContractForAll;
    const updateContractForADealer = this.state.updateContractForADealer;
    new FileEncoder()
      .encode(file)
      .then((data) => {
        const agentContract = {
          contract: data,
          fileName: file.name,
          fileType: "pdf",
          langCode: "",
        };
        AgentContractClient.uploadAgentContract(
          this.props.user.token,
          "NSC",
          this.props.user.market,
          agentContract
        )
          .then(() => {
            this.getAgentContract(updateContractForADealer);
            if (updateContractForAll) {
              this.setState({ uploadSuccessForAll: true });
            } else if (updateContractForADealer) {
              //this.setState({ uploadSuccessForADealer: true });
            }
          })
          .catch(() => {
            this.setState({ showErrorMessage: true });
          })
          .finally(() => {
            this.props.hideOrShow(false);
          });
      })
      .finally(() => {
        this.setState({
          updateContractForAll: false,
          updateContractForADealer: false,
        });
      });
  };

  updateShowDialogForADealerCall = (dealer) => {
    const updateContractForADealer = !this.state.updateContractForADealer;
    this.setState({ updateContractForADealer });
    this.selectedDealer = dealer.dealerId;
  };

  editEmails = () => {
    this.setState({ editMode: true, saveSuccess: false });
  };

  updateChangedList(nsc, newEmail, currentContractEmails) {
    const currentChangedEmails = JSON.parse(
      JSON.stringify(this.state.changedEmails)
    );
    if (newEmail !== this.contractEmailsCopy[nsc]) {
      currentChangedEmails[nsc] = newEmail;
    } else {
      delete currentChangedEmails[nsc];
    }
    this.setState({
      changedEmails: currentChangedEmails,
      contractEmails: currentContractEmails,
    });
  }

  saveChanges = () => {
    this.props.hideOrShow(true);
    this.updateAlltheFlags();
    AgentContractClient.updateContractEmails(this.props.user.token, {
      contractEmails: this.state.changedEmails,
      documentLanguage: this.langCode,
      market: this.props.user.market,
    })
      .then(() => {
        this.setState({
          editMode: false,
          changedEmails: {},
          saveSuccess: true,
          saveError: false,
        });
        this.contractEmailsCopy = JSON.parse(
          JSON.stringify(this.state.contractEmails)
        );
      })
      .catch(() => {
        this.setState({ saveError: true });
      })
      .finally(() => this.props.hideOrShow(false));
  };

  cancelChanges = () => {
    this.setState({
      editMode: false,
      contractEmails: this.contractEmailsCopy,
      changedEmails: {},
      saveError: false,
    });
  };

  render() {
    const fromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "customerContractSubmit"
      ) && this.props.fromNscDealerSearch;
    return (
      <ValidatorForm onSubmit={this.saveChanges}>
        <TermsDialog
          {...this.props}
          open={this.state.updateContractForAll}
          forAll={true}
          contracts={this.state.contracts}
          dialogBody={this.props.t("dealerTermsDialog.branchSubHeader")}
          dialogTitle={this.props.t("dealerTermsDialog.branchTitle")}
          saveText={this.props.t("dealerTermsDialog.apply")}
          confirmAction={this.saveAgentContract}
          onClose={() => this.setState({ updateContractForAll: false })}
        />

        <TermsDialog
          {...this.props}
          open={this.state.updateContractForADealer}
          forAll={false}
          dialogBody={this.props.t("AgentTermsDialog.allSubHeader")}
          dialogTitle={this.props.t("AgentTermsDialog.allTitle")}
          saveText={this.props.t("dealerTermsDialog.apply")}
          currentDealerId={this.selectedDealer}
          confirmAction={this.saveAgentContract}
          onClose={() => this.setState({ updateContractForADealer: false })}
        />
        <div className="pageWrapper">
          <div className="pagePadding">
            {this.viewingAll ? (
              <>
                <div className={styles.subHeader}>
                  {this.props.t("AgentContract.subTitleMain")}
                </div>
                <HasPermissionTo
                  perform={["customerContract:write"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => {
                    return (
                      <div className={styles.buttonDiv}>
                        <Button
                          onClick={() =>
                            this.setState({ updateContractForAll: true })
                          }
                          disabled={fromNscDealerSearch}
                        >
                          <img alt="Upload" src={UploadButton} />
                          <div className={styles.buttonText}>
                            {this.props.t("CustomerContract.setForAll")}
                          </div>
                        </Button>
                        {this.state.uploadSuccessForAll && (
                          <span className={styles.updateCompleteText}>
                            {this.props.t("CustomerContract.updateCompleted")}
                          </span>
                        )}
                      </div>
                    );
                  }}
                />

                {this.state.showErrorMessage && (
                  <div className={styles.errorMessage}>
                    {this.props.t("CustomerContract.errorMessage")}{" "}
                  </div>
                )}
              </>
            ) : (
              <div className={styles.subHeader}>
                {this.props.t("AgentContract.subTitleMain")}
              </div>
            )}
          </div>

          {/** GRID HEADER */}
          <AgentContractHeader
            {...this.props}
            editMode={this.state.editMode}
            editEmails={this.editEmails}
          />

          {
            /** GRID BODY */
            this.state.contracts.map((contract, key) => {
              return (
                <AgentContractRow
                  {...this.props}
                  contract={contract}
                  hideForRetail={this.hideForRetail}
                  editMode={this.state.editMode}
                  updateShowDialogForADealer={
                    this.updateShowDialogForADealerCall
                  }
                  handleContractDownload={this.handleContractDownload}
                  contractEmails={this.state.contractEmails}
                  handleEmailChange={this.handleEmailChange}
                  key={key}
                />
              );
            })
          }

          {this.state.saveError && (
            <div className={styles.saveError}>
              {this.props.t("CustomerContract.saveError")}
            </div>
          )}
          {this.state.saveSuccess && (
            <div className={styles.saveSuccess}>
              {this.props.t("AgentContract.emailUpdated")}
            </div>
          )}
          {this.state.editMode ? (
            Object.keys(this.state.changedEmails).length > 0 ? (
              <div
                className={
                  fromNscDealerSearch
                    ? styles.applyDisableButtonDiv
                    : styles.applyButtonDiv
                }
              >
                <button
                  type="submit"
                  data-testid="saveBtn"
                  disabled={fromNscDealerSearch}
                >
                  {this.props.t("CustomerContract.apply")}
                </button>
              </div>
            ) : (
              <div className={styles.closeButtonDiv}>
                <button onClick={this.cancelChanges}>
                  {this.props.t("CustomerContract.close")}
                </button>
              </div>
            )
          ) : null}
        </div>
      </ValidatorForm>
    );
  }
}

export default withTranslation("emp")(AgentContract);
